/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Property_TakeoverInputs */

const cs_enum_property_takeover = /** @type {(inputs: Enum_Property_TakeoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převzetí nemovitosti`)
};

const en_enum_property_takeover = /** @type {(inputs: Enum_Property_TakeoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takeover`)
};

/**
* | output |
* | --- |
* | "Takeover" |
*
* @param {Enum_Property_TakeoverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_property_takeover = /** @type {((inputs?: Enum_Property_TakeoverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Property_TakeoverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_property_takeover(inputs)
	return cs_enum_property_takeover(inputs)
});